import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/components/Button.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/Card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","CarouselSkeleton"] */ "/app/components/CarouselClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/EventGridClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/FaqAccordionClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/GenericGridClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/LucideIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/provider/StoryblokClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/SectionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useStoryblokState"] */ "/app/node_modules/@storyblok/react/dist/core/use-storyblok-state.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@storyblok/react/dist/rsc/live-editing.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../public/klavika-bold.otf\",\"variable\":\"--font-klavika\"}],\"variableName\":\"klavika\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Fira_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":\"400\",\"variable\":\"--font-fira-sans\"}],\"variableName\":\"fira_sans\"}");
